/* Custom element for the "Read More" button
  * This element is used to create a button that will show/hide a section of text
*/

if (!customElements.get('read-more')) {
  customElements.define('read-more', class extends HTMLElement {
    constructor() {
      super();

      this.settings = {
        // Calculate the max height based on the max number of lines and the line height
        maxHeight: this.maxHeight,
        // get --button-height from CSS
        buttonHeight: parseInt(getComputedStyle(this.button).getPropertyValue('--button-height'), 10) * 10
      }
    }

    connectedCallback() {
      // Check if the content overflow the max height
      if (this.scrollHeight <= this.settings.maxHeight) return;
      this.style.maxHeight = this.settings.maxHeight + this.settings.buttonHeight + 'px';
      this.classList.add('read-more--init');
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    get maxHeight() {
      let maxHeight = Number(this.getAttribute('data-max-height'));
      if (this.getAttribute('data-max-lines')) {
        maxHeight = this.getAttribute('data-max-lines') * parseInt(getComputedStyle(this).lineHeight, 10);
      } else if (this.getAttribute('data-max-lines-desktop') && window.matchMedia('(min-width: 750px)').matches) {
        maxHeight = this.getAttribute('data-max-lines-desktop') * parseInt(getComputedStyle(this).lineHeight, 10);
      } else if (this.getAttribute('data-max-lines-mobile') && window.matchMedia('(max-width: 749px)').matches) {
        maxHeight = this.getAttribute('data-max-lines-mobile') * parseInt(getComputedStyle(this).lineHeight, 10);
      }

      return maxHeight;
    }

    toggle() {
      this.classList.toggle('read-more--open');
      this.button.setAttribute('aria-expanded', this.classList.contains('read-more--open'));
    }

    get button() {
      return this.querySelector('button.read-more__button');
    }
  });
}
